import { DefaultOptionColor, OPTION_COLORS } from "./constants/OptionsColors";

const getOptionTextColor = (optionType: string, optionValue: string): string => {
    return OPTION_COLORS[optionType]?.[optionValue] || DefaultOptionColor;
};

export default getOptionTextColor;

